import {processThumb, processThumb2, processThumb3} from "../assets/images";

const workingProcessData = [
  {
    id: "01",
    title: "Discovery & Planning",
    description:
      "I explore your goals, audience, and brand vision to set a clear and strategic direction.",
    image: processThumb,
  },
  {
    id: "02",
    title: "Design-to-Code Execution",
    description:
      "I convert Figma designs into responsive, modern frontend code using React and Tailwind.",
    image: processThumb2,
  },
  {
    id: "03",
    title: "Build, Integrate & Launch",
    description:
      "I develop full-stack logic, integrate APIs, and ensure a smooth and secure launch.",
    image: processThumb3,
  },
];

export {workingProcessData};
